import { coreTranslations } from './translations';

// Index-specific translation additions (only new keys, no base spreading)
const indexSpecificUpdates = {
  FR: {
    start_now: 'Commencer gratuitement',
    start_now_no_trial: 'Commencer',
    free_trial_banner_title: 'Essai gratuit 🎁',
    free_trial_banner_description: 'Commencez maintenant avec 4 jours d\'essai gratuit pour tester toutes nos fonctionnalités premium.',
    hours: 'heures',
    minutes: 'minutes',
    seconds: 'secondes',
    until_midnight: 'jusqu\'à minuit',
    months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    days: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    date_format: "Le {day} {date} {month} {year}"
  },
  EN: {
    start_now: 'Start for free',
    start_now_no_trial: 'Start now',
    free_trial_banner_title: 'Free Trial 🎁',
    free_trial_banner_description: 'Start now with a 4-day free trial to test all our premium features.',
    hours: 'hours',
    minutes: 'minutes',
    seconds: 'seconds',
    until_midnight: 'until midnight',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    date_format: "{day}, {month} {date}, {year}"
  },
  ES: {
    start_now: 'Empezar gratis',
    start_now_no_trial: 'Empezar ahora',
    free_trial_banner_title: 'Prueba gratuita 🎁',
    free_trial_banner_description: 'Comienza ahora con 4 días de prueba gratuita para probar todas nuestras funciones premium.',
    hours: 'horas',
    minutes: 'minutos',
    seconds: 'segundos',
    until_midnight: 'hasta medianoche',
    months: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    days: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    date_format: "{day} {date} de {month} de {year}"
  },
  RU: {
    start_now: 'Начать бесплатно',
    start_now_no_trial: 'Начать сейчас',
    free_trial_banner_title: 'Бесплатная пробная версия 🎁',
    free_trial_banner_description: 'Начните сейчас с 4-дневной бесплатной пробной версией, чтобы протестировать все наши премиум-функции.',
    hours: 'часов',
    minutes: 'минут',
    seconds: 'секунд',
    until_midnight: 'до полуночи',
    months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
    days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
    date_format: "{day}, {date} {month} {year}"
  }
};

// Final translations with proper merging
export const translations = {
  FR: {
    ...coreTranslations.FR,
    ...indexSpecificUpdates.FR
  },
  EN: {
    ...coreTranslations.EN,
    ...indexSpecificUpdates.EN
  },
  ES: {
    ...coreTranslations.ES,
    ...indexSpecificUpdates.ES
  },
  RU: {
    ...coreTranslations.RU,
    ...indexSpecificUpdates.RU
  }
};

// Export languages with full information
export const languages = [
  { code: 'FR', name: 'Français', flag: '🇫🇷' },
  { code: 'EN', name: 'English', flag: '🇬🇧' },
  { code: 'ES', name: 'Español', flag: '🇪🇸' },
  { code: 'RU', name: 'Русский', flag: '🇷🇺' }
];